const MAX_LEN = 256;
const FALLBACK = "/dashboard";

/** Relative in-app path only — blocks open redirects (`//…`). */
export function safePostLoginPath(raw: string | null | undefined): string {
  if (raw == null || typeof raw !== "string") return FALLBACK;
  const t = raw.trim();
  if (t.length === 0 || t.length > MAX_LEN) return FALLBACK;
  if (!t.startsWith("/") || t.startsWith("//")) return FALLBACK;
  return t;
}
